/* src/app/shared/components/tenant-selection-panel/tenant-selection-panel.component.scss */
.tenant-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  -webkit-backdrop-filter: blur(1.5px);
  backdrop-filter: blur(1.5px);
  z-index: 1000;
}
.tenant-modal-container {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 20vw;
  max-height: 60vh;
  background: #fff;
  border-radius: 1.5rem 1.5rem 1.5rem 1.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2509803922);
  transform: translate(-50%, -50%);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  animation: modal-pop 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}
.tenant-modal-header {
  padding: 1.5rem 1.5rem 0.5rem 2.5rem;
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.tenant-modal-header .close-icon {
  position: absolute;
  top: 10px;
  right: 17px;
  font-size: 1.5rem;
  color: #d5d5d5;
  cursor: pointer;
  transition: color 0.2s;
}
.tenant-modal-header .close-icon:hover {
  color: #afafaf;
}
.tenant-modal-content {
  flex: 1;
  padding: 1rem 1.5rem;
  overflow-y: auto;
  border-top-style: solid;
  border-top-width: 1px;
  border-color: #cccccc;
}
.tenant-option {
  background-color: #eeeeee;
  height: fit-content;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  font-size: larger;
  vertical-align: middle;
}
.tenant-option i {
  color: #d5d5d5;
  margin-right: 10px;
  text-align: center;
  font-size: 35pt;
}
.tenant-option:hover {
  background-color: #dddddd;
  cursor: pointer;
}
.tenant-option:hover i {
  color: #afafaf;
}
.tenant-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 0.5rem 1.5rem 1.5rem 1.5rem;
  border-bottom-left-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
}
@keyframes modal-pop {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.5);
  }
  80% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.05);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
/*# sourceMappingURL=tenant-selection-panel.component-IQGZ4KJC.css.map */
